import React, { createContext, useCallback, useContext, useEffect, useId, useMemo, useRef, useState } from 'react';

const Context = createContext(null);
export function VesselNavigationProvider({children}) {
  const [entries,setEntries]=useState({});
  const register=useCallback((id,entry)=>setEntries(current=>{const next={...current};if(entry)next[id]=entry;else delete next[id];return next;}),[]);
  const value=useMemo(()=>({register,config:Object.values(entries).sort((a,b)=>(b.priority||0)-(a.priority||0))[0]}),[entries,register]);
  return <Context.Provider value={value}>{children}</Context.Provider>;
}
export function useVesselNavigation(config) {
  const context=useContext(Context);
  const register=context?.register;
  const id=useId();
  const latest=useRef(config);latest.current=config;
  const signature=JSON.stringify(config ? {label:config.label,priority:config.priority,items:config.items?.map(({id,label,selected,disabled,to,onSelect})=>({id,label,selected,disabled,to,hasAction:!!onSelect})),tools:config.tools?.map(({id,label,disabled})=>({id,label,disabled}))}:null);
  useEffect(()=>{
    if(!register || !latest.current)return undefined;
    const current=latest.current;
    const bind=key=>(current[key]||[]).map((item,index)=>({...item,onSelect:item.onSelect?()=>latest.current?.[key]?.[index]?.onSelect?.():undefined}));
    register(id,{...current,items:bind('items'),tools:bind('tools'),beforeLeave:(action)=>latest.current?.beforeLeave?.(action) !== false});
    return()=>register(id,null);
  },[register,id,signature]);
}
export function useCurrentVesselNavigation(){return useContext(Context)?.config;}
